import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {QualityGateFilter, TransactionTagsEntry, TransactionTypeNullEntry} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";
@Component({
  selector: "app-null-transaction-processed",
  // imports: [],
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class NullTransactionProcessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  processedTransactionTypeNullEntries: TransactionTypeNullEntry[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getProcessedTransactionTypeNullEntries();
  }

  onUpdateClick(share: any) {}

  onSearch() {
        const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getProcessedTransactionTypeNullEntries();
  }
  preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }

  getProcessedTransactionTypeNullEntries() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "PROCESSED",
      qualityGateType: "Transaction_Type_null",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.processedTransactionTypeNullEntries = value.transactionTypeNullEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedTransactionTypeNullEntries?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
}
